export const pasien = {
  path: "/pasien",
  name: "pasien",
  hidden: false,
  component: () => import("@/components/pasien/index"),
  meta: {
    title: "Pasien",
    icon: "fa-user",
    roles: ["BT123", "dokter"]
  }
};
export default pasien;



// WEBPACK FOOTER //
// ./src/router/modules/pasien.js